import type { UseMutateFunction } from "@tanstack/react-query";

import { PaymentsCreateOrderAttributes, PaymentsProduct } from "~/api/Api";

import { Icon } from "../../../assets/icons/Icon";
// Reuse the Brand Links package styles — the Done-for-You service pages share
// one layout (matches LlmCitationsPackage, which imports the same module).
import styles from "../brandLinksPackage/BrandLinksPackage.module.scss";
import { FeatureSection } from "../featureSection/FeatureSection";
import { PricingCard } from "../pricingCard/PricingCard";

const text2 = [
  {
    title: "We Find the Opportunities",
    description: `Once your order is placed, our team will review your Community link tasks for Reddit and Quora and find the best opportunities. We will research your business and create comments in line with community guidelines which reference your brand name. If any additional information is needed, we will contact you directly.`,
  },
  {
    title: "Track Delivery in Your Dashboard",
    description: `Completed placements are added to your dashboard as they are delivered. Most campaigns are completed within 30 days, and we'll notify you when your order is finished.`,
  },
];

interface CommunityLinksPackageProps {
  product: PaymentsProduct;
  targetSites: { value: string; label: string }[];
  createOrder: UseMutateFunction<
    unknown,
    unknown,
    PaymentsCreateOrderAttributes,
    unknown
  >;
  isCreateOrderPending: boolean;
}

const descriptionList = (value: string | null) => [
  `${value} Brand mentions`,
  `Answers Optimized for AI Citations`,
  `Placements on Reddit and Quora Exclusively`,
  `30 Day Delivery`,
];

export const CommunityLinksPackage = ({
  product,
  targetSites,
  createOrder,
  isCreateOrderPending,
}: CommunityLinksPackageProps) => {
  return (
    <div className={styles.brandLinksPackage}>
      <main className={styles.brandLinksPackageMain}>
        <div className={styles.brandLinksGrid}>
          <section className={styles.descriptionCard}>
            <div className={styles.descriptionWrapper}>
              <h3 className={styles.descriptionTitle}>
                We&apos;ll Create Your Community Links For You
              </h3>
              <div className={styles.descriptionContent}>
                <div className={styles.brandLinksImage}>
                  <Icon
                    iconName="BrandLinksImage1"
                    width="19.125rem"
                    height="12.5rem"
                  />
                </div>

                <div className={styles.descriptionTextContainer}>
                  <p className={styles.descriptionText}>
                    Community Links help increase your brand visibility in AI
                    search. They are tracked by Google and used for LLM model
                    training, agents and are often cited in chat answers.
                  </p>
                  <p className={styles.descriptionText}>
                    Our trained team will research, create and optimize these
                    placements according to community guidelines using your
                    business information and brand name.
                  </p>
                  <p className={styles.descriptionText}>
                    This Done-For-You service is for mentions on Reddit and
                    Quora threads only, as these provide the most value for AI
                    search.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className={styles.brandLinksPackagePricing}>
            {product.prices?.map((price) => (
              <PricingCard
                key={price.id}
                price={price}
                targetSites={targetSites}
                createOrder={createOrder}
                list={descriptionList(price.size)}
                isCreateOrderPending={isCreateOrderPending}
              />
            ))}
          </section>
        </div>
        <FeatureSection
          icon="BrandLinksImage2"
          title="How It Works"
          text={text2}
          reversed
        />
      </main>
    </div>
  );
};
